/**
 * OnlyPlanks MAP email + OTP price unlock
 * Runs only on body.op-map-hide without .op-map-unlocked
 * API: window.OP_MAP_UNLOCK_API (default CF Worker)
 */
(function () {
  'use strict';

  var COOKIE = 'op_map_unlock';
  var LS_KEY = 'op_map_unlock';
  var API =
    (typeof window !== 'undefined' && window.OP_MAP_UNLOCK_API) ||
    'https://onlyplanks-price-unlock.richard-b94.workers.dev';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function hasUnlockCookie() {
    try {
      return document.cookie && /(^|;\s*)op_map_unlock=1(;|$)/.test(document.cookie);
    } catch (e) {
      return false;
    }
  }

  function hasUnlockFlag() {
    try {
      return window.localStorage && localStorage.getItem(LS_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function setUnlockClient() {
    var maxAge = 2592000; // 30 days
    var secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie =
      COOKIE + '=1; Max-Age=' + maxAge + '; Path=/; SameSite=Lax' + secure;
    try {
      localStorage.setItem(LS_KEY, '1');
    } catch (e) {}
    document.body.classList.add('op-map-unlocked');
    document.documentElement.classList.add('op-map-unlocked');
  }

  function productHandle() {
    var path = (location.pathname || '').replace(/\/+$/, '');
    var m = path.match(/\/products\/([^/?#]+)/);
    if (m) return decodeURIComponent(m[1]);
    var el = document.querySelector('[data-product-handle]');
    if (el && el.getAttribute('data-product-handle')) {
      return el.getAttribute('data-product-handle');
    }
    return '';
  }

  function findMount() {
    var disclaimer = document.querySelector('.op-map-disclaimer');
    if (disclaimer) return disclaimer;
    var candidates = [
      '.product-information',
      '.product-details',
      'product-information',
      '[data-product-details]',
      '.product__info-container',
      'main .product',
    ];
    for (var i = 0; i < candidates.length; i++) {
      var el = document.querySelector(candidates[i]);
      if (el) return el;
    }
    return document.querySelector('main') || document.body;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }


  function readPpm2() {
    try {
      if (typeof window !== 'undefined' && window.OP_MAP_PPM2 != null && window.OP_MAP_PPM2 !== '') {
        var w = Number(window.OP_MAP_PPM2);
        if (!isNaN(w) && w > 0) return w;
      }
    } catch (e) {}
    try {
      var raw =
        (document.body && document.body.dataset && document.body.dataset.opMapPpm2) ||
        (document.body && document.body.getAttribute('data-op-map-ppm2'));
      if (raw != null && String(raw).trim() !== '') {
        var n = Number(String(raw).trim());
        if (!isNaN(n) && n > 0) return n;
      }
    } catch (e2) {}
    return null;
  }

  function formatPpm2(n) {
    var x = Number(n);
    if (isNaN(x)) return '';
    try {
      return x.toLocaleString('en-AU', {
        style: 'currency',
        currency: 'AUD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } catch (e) {
      return '$' + x.toFixed(2);
    }
  }

  function gateLeadCopy() {
    // Never show the locked $/m² in the gate — that defeats MAP hide.
    return 'Warehouse pricing on this range is available after a quick email unlock. Enter your email to see the $/m² and add to cart.';
  }

  function buildGate() {
    var wrap = document.createElement('div');
    wrap.className = 'op-map-gate';
    wrap.setAttribute('role', 'region');
    wrap.setAttribute('aria-label', 'Unlock warehouse price');
    var lead = gateLeadCopy();
    wrap.innerHTML =
      '<div class="op-map-gate__inner">' +
      '<p class="op-map-gate__lead">' +
      esc(lead) +
      '</p>' +
      '<div class="op-map-gate__step" data-step="email">' +
      '<label class="op-map-gate__label" for="op-map-email">Email</label>' +
      '<input class="op-map-gate__input" id="op-map-email" type="email" name="email" autocomplete="email" required placeholder="you@example.com" />' +
      '<label class="op-map-gate__consent">' +
      '<input type="checkbox" id="op-map-consent" name="consent" required />' +
      '<span>Email me this warehouse price and occasional OnlyPlanks deals</span>' +
      '</label>' +
      '<button type="button" class="op-map-gate__btn" id="op-map-request">Send code</button>' +
      '</div>' +
      '<div class="op-map-gate__step" data-step="code" hidden>' +
      '<p class="op-map-gate__hint" id="op-map-sent-hint" aria-live="polite">We emailed a 6-digit code. Enter it below (valid ~10 minutes).</p>' +
      '<label class="op-map-gate__label" for="op-map-code">Code</label>' +
      '<input class="op-map-gate__input" id="op-map-code" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="6" autocomplete="one-time-code" placeholder="123456" />' +
      '<button type="button" class="op-map-gate__btn" id="op-map-verify">Unlock price</button>' +
      '<button type="button" class="op-map-gate__link" id="op-map-resend">Resend code</button>' +
      '<button type="button" class="op-map-gate__link" id="op-map-change">Use a different email</button>' +
      '</div>' +
      '<p class="op-map-gate__msg" id="op-map-msg" role="status" aria-live="polite" aria-atomic="true"></p>' +
      '<p class="op-map-gate__trade">Tradie? <a href="/products/trade-unlock">Trade Unlock</a> is separate — ongoing $/m² cuts with a Trade ID.</p>' +
      '</div>';
    return wrap;
  }

  function setMsg(el, text, kind) {
    el.textContent = text || '';
    el.className = 'op-map-gate__msg' + (kind ? ' op-map-gate__msg--' + kind : '');
    // make sure a result is always visible on screen
    if (text) {
      try { el.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {}
    }
  }

  function post(path, body) {
    // 20s timeout so the button never sits on "Sending…" forever
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = setTimeout(function () {
      try { if (ctrl) ctrl.abort(); } catch (e) {}
    }, 20000);
    var opts = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'omit',
      body: JSON.stringify(body),
    };
    if (ctrl) opts.signal = ctrl.signal;
    return fetch(API.replace(/\/$/, '') + path, opts).then(function (res) {
      clearTimeout(timer);
      return res.json().catch(function () {
        return {};
      }).then(function (data) {
        return { ok: res.ok, status: res.status, data: data };
      });
    }, function (err) {
      clearTimeout(timer);
      throw err;
    });
  }

  function wire(gate) {
    var emailStep = gate.querySelector('[data-step="email"]');
    var codeStep = gate.querySelector('[data-step="code"]');
    var emailInput = gate.querySelector('#op-map-email');
    var consentInput = gate.querySelector('#op-map-consent');
    var codeInput = gate.querySelector('#op-map-code');
    var msg = gate.querySelector('#op-map-msg');
    var sentHint = gate.querySelector('#op-map-sent-hint');
    var sendBtn = gate.querySelector('#op-map-request');
    var verifyBtn = gate.querySelector('#op-map-verify');
    var resendBtn = gate.querySelector('#op-map-resend');
    var changeBtn = gate.querySelector('#op-map-change');
    var handle = productHandle();
    var lastEmail = '';
    var cooldownTimer = null;
    var SEND_LABEL = sendBtn.textContent;
    var VERIFY_LABEL = verifyBtn.textContent;

    function busy(btn, on, busyLabel, idleLabel) {
      if (!btn) return;
      btn.disabled = !!on;
      btn.setAttribute('aria-busy', on ? 'true' : 'false');
      if (busyLabel && idleLabel) btn.textContent = on ? busyLabel : idleLabel;
    }

    function startCooldown(seconds) {
      var left = seconds;
      clearInterval(cooldownTimer);
      resendBtn.disabled = true;
      function tick() {
        if (left <= 0) {
          clearInterval(cooldownTimer);
          resendBtn.disabled = false;
          resendBtn.textContent = 'Resend code';
          return;
        }
        resendBtn.textContent = 'Resend code (in ' + left + 's)';
        left -= 1;
      }
      tick();
      cooldownTimer = setInterval(tick, 1000);
    }

    function flag(el) {
      try {
        el.setAttribute('aria-invalid', 'true');
        el.focus();
        el.addEventListener('input', function clear() {
          el.removeAttribute('aria-invalid');
          el.removeEventListener('input', clear);
        });
      } catch (e) {}
    }

    function requestCode(isResend) {
      var email = (emailInput.value || lastEmail || '').trim().toLowerCase();
      if (!email || email.indexOf('@') < 1 || email.indexOf('.', email.indexOf('@')) < 0) {
        setMsg(msg, 'Please enter a valid email address, e.g. you@example.com.', 'err');
        flag(emailInput);
        return;
      }
      if (!isResend && !consentInput.checked) {
        setMsg(msg, 'Please tick the box above so we can email you the code.', 'err');
        flag(consentInput);
        return;
      }
      var btn = isResend ? resendBtn : sendBtn;
      busy(sendBtn, true, 'Sending…', SEND_LABEL);
      if (isResend) {
        resendBtn.disabled = true;
        resendBtn.textContent = 'Sending…';
      }
      setMsg(msg, 'Sending code to ' + email + '…', 'info');
      post('/v1/request', { email: email, handle: handle, consent: true })
        .then(function (r) {
          busy(sendBtn, false, 'Sending…', SEND_LABEL);
          if (r.status === 429) {
            setMsg(msg, (r.data && r.data.error) || 'Too many requests. Wait a minute and try again.', 'err');
            if (isResend) startCooldown(30);
            return;
          }
          if (!r.ok) {
            setMsg(
              msg,
              ((r.data && r.data.error) || 'Could not send the code.') +
                ' Try again, or email contactus@onlyplanks.com.au and we will unlock it for you.',
              'err'
            );
            if (isResend) startCooldown(5);
            return;
          }
          lastEmail = email;
          emailStep.hidden = true;
          codeStep.hidden = false;
          if (sentHint) {
            sentHint.textContent =
              'Code sent to ' + email + '. Check your inbox and junk/spam folder. It can take a minute. The code is valid for about 10 minutes.';
          }
          setMsg(msg, (isResend ? 'New code sent to ' : 'Code sent to ') + email + ' — check your junk folder too.', 'ok');
          startCooldown(30);
          try { codeInput.focus(); } catch (e) {}
        })
        .catch(function (err) {
          busy(sendBtn, false, 'Sending…', SEND_LABEL);
          var timedOut = err && err.name === 'AbortError';
          setMsg(
            msg,
            timedOut
              ? 'That is taking too long. Please try again, or email contactus@onlyplanks.com.au and we will unlock it for you.'
              : 'Network error, the code was not sent. Check your connection and try again.',
            'err'
          );
          if (isResend) startCooldown(5);
        });
    }

    function verifyCode() {
      var email = lastEmail || (emailInput.value || '').trim().toLowerCase();
      var code = (codeInput.value || '').replace(/\D/g, '');
      if (!email) {
        setMsg(msg, 'Start again with your email.', 'err');
        emailStep.hidden = false;
        codeStep.hidden = true;
        return;
      }
      if (code.length !== 6) {
        setMsg(msg, 'Enter the 6-digit code from your email.', 'err');
        flag(codeInput);
        return;
      }
      busy(verifyBtn, true, 'Checking…', VERIFY_LABEL);
      setMsg(msg, 'Checking your code…', 'info');
      post('/v1/verify', { email: email, code: code, handle: handle })
        .then(function (r) {
          busy(verifyBtn, false, 'Checking…', VERIFY_LABEL);
          if (r.status === 429) {
            setMsg(msg, (r.data && r.data.error) || 'Too many attempts. Wait a bit and try again.', 'err');
            return;
          }
          if (!r.ok) {
            setMsg(msg, (r.data && r.data.error) || 'That code did not work. Check it and try again, or resend a new code.', 'err');
            flag(codeInput);
            return;
          }
          setUnlockClient();
          setMsg(msg, 'Unlocked. Showing warehouse price…', 'ok');
          setTimeout(function () {
            location.reload();
          }, 400);
        })
        .catch(function (err) {
          busy(verifyBtn, false, 'Checking…', VERIFY_LABEL);
          setMsg(
            msg,
            err && err.name === 'AbortError'
              ? 'That is taking too long. Please try again.'
              : 'Network error. Check your connection and try again.',
            'err'
          );
        });
    }

    sendBtn.addEventListener('click', function () { requestCode(false); });
    verifyBtn.addEventListener('click', verifyCode);
    resendBtn.addEventListener('click', function () { requestCode(true); });
    changeBtn.addEventListener('click', function () {
      clearInterval(cooldownTimer);
      emailStep.hidden = false;
      codeStep.hidden = true;
      setMsg(msg, '', '');
      try { emailInput.focus(); emailInput.select(); } catch (e) {}
    });
    codeInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        verifyCode();
      }
    });
    emailInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        requestCode(false);
      }
    });
  }

  ready(function () {
    var body = document.body;
    if (!body || !body.classList.contains('op-map-hide')) return;
    if (body.classList.contains('op-map-unlocked')) return;
    if (hasUnlockCookie() || hasUnlockFlag()) {
      setUnlockClient();
      return;
    }
    if (document.querySelector('.op-map-gate')) return;
    var mount = findMount();
    var gate = buildGate();
    if (mount.classList && mount.classList.contains('op-map-disclaimer')) {
      mount.insertAdjacentElement('beforebegin', gate);
    } else {
      mount.insertAdjacentElement('afterbegin', gate);
    }
    wire(gate);
  });
})();
